// PRD 9.2 — what makes a trial-points exception submittable. Pure so it can be tested without the
// modal; the server re-validates all of it, this only keeps the operator from a pointless round trip.

// DECIMAL(4,2) in MySQL, so anything finer than 2dp is silently rounded on the way in.
export const TRIAL_POINTS_EXCEPTION_MAX_CHARGE = 10;
// VARCHAR(500) NOT NULL — a longer reason is error 1406, or a silent truncation.
export const TRIAL_POINTS_EXCEPTION_MAX_REASON = 500;
export const TRIAL_POINTS_EXCEPTION_MIN_REASON = 3;

// PROD-10235: GC rows can carry is_trial, but only a 1-on-1 (YOGA) trial has trial points to adjust.
export function can_open_trial_points_exception(details) {
  return Number(details?.is_trial) === 1 && details?.session_type === 'YOGA';
}

// A charge the column can store exactly. CustomInput drops min/max/step, so this is the only gate.
export function is_storable_charge(raw) {
  if (raw === '' || raw === null || raw === undefined) return false;
  const charge = Number(raw);
  if (!Number.isFinite(charge)) return false;
  if (charge < 0 || charge > TRIAL_POINTS_EXCEPTION_MAX_CHARGE) return false;
  // 0.005 would pass the range check and then be stored as 0.01 — a value nobody typed.
  return Number(charge.toFixed(2)) === charge;
}

export function is_valid_reason(raw) {
  const reason = (raw || '').trim();
  return (
    reason.length >= TRIAL_POINTS_EXCEPTION_MIN_REASON &&
    reason.length <= TRIAL_POINTS_EXCEPTION_MAX_REASON
  );
}

// An exception must DO something — a reason alone would save a note that changes no points.
export function is_valid_trial_points_exception({ waived, custom_enabled, charge, reason }) {
  if (!is_valid_reason(reason)) return false;
  if (waived) return true;
  if (!custom_enabled) return false;
  return is_storable_charge(charge);
}

// PROD-9786: the editable form for one leg, seeded from its stored exception.
export function form_from_leg(leg) {
  const ex = (leg && leg.exception) || null;
  const waived = !!ex && ex.is_waived === 1;
  const has_charge = !!ex && !waived && ex.custom_charge !== null && ex.custom_charge !== undefined;
  return {
    waived,
    custom_enabled: has_charge,
    charge: has_charge ? String(ex.custom_charge) : '',
    reason: (ex && ex.reason) || ''
  };
}

// PROD-9786: the update_trial_points_exception body for one leg; a waiver never carries a charge.
export function build_exception_payload(session_uuid, leg, form) {
  const custom = !form.waived && form.custom_enabled;
  return {
    session_uuid,
    teacher_uuid: leg.teacher_uuid,
    is_waived: form.waived ? 1 : 0,
    custom_charge: custom ? Number(form.charge) : null,
    reason: (form.reason || '').trim()
  };
}

// Notifications take strings only; apis can put an object in message.
export function exception_error_text(e) {
  const message = e && e.response && e.response.data && e.response.data.message;
  return typeof message === 'string' && message
    ? message
    : 'Some error occured. Please contact dev team';
}
